import React from 'react';
import * as R from 'ramda';
// components
import { withTabsMui } from '../../../components/tabs-mui';
// feature dispatch-report
import Order from './order';
import CloByTel from './order-by-load';
import PivotOrder from './components/pivot-order';
//////////////////////////////////////////////////

const OrderWrapper = withTabsMui((props) => {
  const { activeTab, handleSetActiveTab } = props;

  if (R.equals(activeTab, 0)) {
    return <Order activeTab={activeTab} handleSetActiveTab={handleSetActiveTab} />;
  } else if (R.equals(activeTab, 1)) {
    return <CloByTel activeTab={activeTab} handleSetActiveTab={handleSetActiveTab} />;
  }

  return <PivotOrder {...props} />;
});

export const Component = withTabsMui(OrderWrapper);

export default OrderWrapper;
